export default __webpack_public_path__ + "static/tools.url-bde8d6d17b0f7c9446e045c563614ae0.svg";